import React, { useState, useCallback, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import { ButtonWrapper, Column, ButtonIcon, Text, ActiveOffersText, ActiveOffersNumber } from "./styles";

import OfferService from "../../../../../services/Offer";

function ActivePromotions({ theme, link = "#!" }) {
    const history = useHistory();
    const [activeOffers, setActiveOffers] = useState([]);
    const [loadedActiveOffers, setLoadedActiveOffers] = useState(false);

    const handleActiveOffers = useCallback(() => {
        const offerService = new OfferService();
        
        offerService.listActiveFromUser().then((response) => {
            setActiveOffers(response.data.payload);
            setLoadedActiveOffers(true);
          });
    }, []);

    useEffect(() => {
        handleActiveOffers();
    }, [handleActiveOffers])
    
    return (
        <ButtonWrapper className="ActivePromotionsButton" theming={theme}>
            <Link to={{ pathname: link, search: history.location.search }}>
            <Column className="Column">
                <ButtonIcon className="AwesomeIcon">
                    <Icon icon={["fal", "tags"]} />
                </ButtonIcon>
                <Text>
                    {loadedActiveOffers? 
                        !activeOffers
                            ? ("Nenhuma Oferta ativa")
                            : <ActiveOffersText>
                                Você ativou
                                <ActiveOffersNumber>
                                    {activeOffers?.length} {activeOffers?.length === 1 ? 'oferta' : 'ofertas'}
                                </ActiveOffersNumber>
                            </ActiveOffersText>
                        : <></>
                    }

                </Text>
            </Column>

            <Column className="Column">
                <ButtonIcon className="AwesomeIcon">
                    <Icon icon={["far", "chevron-right"]} />
                </ButtonIcon>
            </Column>
            </Link>
        </ButtonWrapper>
    )
}

export default ActivePromotions;

ActivePromotions.propTypes = {
    activePromotions: PropTypes.number
}